const translations = {
    invite: 'Invite',
    inviteUser: 'Invite User',
    numberOfSeats: 'Number of Seats'
};

export default translations;
